import { Button, Col, Empty, Flex, Form, Image, Input, Radio, Row, Space, Tooltip, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { FC, useEffect, useMemo, useState } from "react";
import { EmailDetailsModal, EmailsStatus } from "src/components/pages/emails-data";
import NoData from "src/shared/images/noData.png";
import { ConfirmButtons, Modal, StatusTag, Table, TableHeader, TextEditor } from "src/components/ui";
import { App } from "src/types";
import { MinusOutlined } from "@ant-design/icons";
import { emailsData } from "../../info";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import tz from "moment-timezone";
import { outreachEmailsSelector } from "src/store/outreach-emails";
import { useNavigate } from "react-router";
import { fullUserSelector } from "src/store/user";
import { getUnifiedInboxAll } from "src/store/outreach-emails/asyncRequests";
import { AppDispatch } from "src/store";
import { DownloadEmailAnalytics } from "src/components/pages/analytics-components/DownloadEmailAnalytics";
import { outreachCampaignSelector } from "src/store/outreach-campaigns";
import { openPopUp } from "src/store/outreach-phones";

interface EmailsTableProps {
  isTourStep?: boolean;
  campaignId: "all" | string;
  activeId: string;
}

export const EmailsTable: FC<EmailsTableProps> = ({ isTourStep, campaignId, activeId }) => {
  const navigate = useNavigate();
  const [selectedContact, setSelectedContact] = useState<App.EmailsEntity | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [filterBox, setFilterBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tourStepData, setTourStepData] = useState(emailsData);
  const [actCampIds, setActCampIds] = useState([]);
  const [tableData, setTableData] = useState(emailsData);
  const [openDownloadAnaltrics, setOpenDownloadAnaltrics] = useState(false);
  const memoizedTourStepData = useMemo(() => tourStepData, [tourStepData]);

  const { sdBarCollapsed, idArrExpToSee, user } = useSelector(fullUserSelector);

  const { dataAll, analyticDates } = useSelector(outreachEmailsSelector);
  // console.log(dataAll, "dataAll");

  useEffect(() => {
    setTourStepData(emailsData);
  }, [emailsData]);

  useEffect(() => {
    const actCamps = dataAll?.campainIdsActive;
    setActCampIds(actCamps || []);
  }, [dataAll]);

  const showModal = () => {
    setOpenModal(true);
  };

  const onCancel = () => {
    setOpenModal(false);
  };
  const formatUnixTimestamp = (unixTimestamp) => {
    const date = tz.unix(unixTimestamp).tz(tz.tz.guess());
    return date.format("MMMM Do 'YY [at] h:mm A");
  };
  // console.log(activeId, "activeId");
  // const { allCampsList } = useSelector(outreachCampaignSelector);
  // const [campToCopId, setCampToCopId] = useState<string | undefined>();
  // const [searchTerm, setSearchTerm] = useState<string>("");
  // const handleRadioBtnChange = (e: any) => {
  //   setCampToCopId(e.target.value);
  //   form.setFieldsValue({ camptocopy: e?.target?.value }); // Ensure form updates with selected campaign
  // };
  // const filteredCampaigns = allCampsList?.filter((item) => item?.campName?.toLowerCase()?.includes(searchTerm?.toLowerCase()))?.slice(0, 5);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const closeModal = () => {
  //   onCancel();
  //   setTimeout(() => {
  //     setIsSubmitting(false);
  //   }, 1000);
  // };

  const columns = [
    {
      title: "Contact name",
      // className: "emails-contact-name",
      render: (record) => {
        console.log(record, "RECORDqwewqeqwe");
        return (
          <Tooltip
            placement={"top"}
            title={
              <>
                <b>Name: </b>
                {record?.first_name || ""} {record?.last_name || ""}
                {record?.job_title ? (
                  <>
                    <br />
                    <b>Job Title: </b>
                    {record?.job_title}
                  </>
                ) : (
                  ""
                )}
                {record?.company_name || record?.company_url ? (
                  <>
                    <br />
                    <b> Company: </b>
                    {record?.company_name || record?.company_url}
                  </>
                ) : (
                  ""
                )}
                {record?.email ? (
                  <>
                    <br />
                    <b> Email: </b>
                    {record?.email}
                  </>
                ) : (
                  ""
                )}
                {/* <br />
                <b>Company:</b>
                {record?.company_name || record?.company_url||''} */}
              </>
            }
          >
            {" "}
            <div
              style={{ cursor: "pointer", borderRadius: "8px", padding: "40px 5px" }}
              onClick={() => dispatch(openPopUp(record))}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              {record.first_name ? (
                <>
                  {record.first_name} {record.last_name}{" "}
                </>
              ) : (
                <MinusOutlined />
              )}
            </div>{" "}
          </Tooltip>
        );
      },
      // <Typography.Paragraph
      //   onClick={() => {
      //     setSelectedContact(record);
      //     showModal();
      //   }}
      // >{`${record.first_name} ${record.last_name}`}</Typography.Paragraph>
      dataIndex: "prospect",
      align: "left",
      width: "140px",
    },
    idArrExpToSee?.some((id) => id !== user?.id)
      ? {
          title: "Team member",
          dataIndex: "analyticToShow",
          render: (record) => (
            <Tooltip
              placement={"top"}
              title={
                <>
                  <b> Team members analytic</b> <br />
                  <br />
                  Name: {record?.client?.first_name} {record?.client?.last_name}
                  <br />
                  <br />
                  Team Members Email:{" "}
                  {user?.email?.trim()?.toLowerCase() === record?.client?.email?.trim()?.toLowerCase()
                    ? "This is your campaigns analytics"
                    : record?.client?.email?.trim()?.toLowerCase()}
                </>
              }
            >
              {`${record?.client?.first_name} ${record?.client?.last_name}`?.trim()?.length > 11 ? (
                <> {`${record?.client?.first_name} ${record?.client?.last_name}`?.slice(0, 11)}...</>
              ) : (
                `${record?.client?.first_name} ${record?.client?.last_name}`
              )}
            </Tooltip>
          ),
          width: "120px",
        }
      : null,
    {
      title: activeId !== "email_replied" ? "Email Sent" : "Email Replied",
      dataIndex: "analyticToShow",
      render: (record) => {
        // force null or write deleted campaign if not in platform anymore
        const fixCampName =
          !record?.campaign_id || actCampIds?.includes(record?.campaign_id) ? record?.campaign_name : `${record?.campaign_name} (Deleted campaign)`;

        const actCampId = !!record?.campaign_id && actCampIds?.includes(record?.campaign_id) ? record?.campaign_id : null;

        if (activeId !== "email_replied") {
          // const sanitizedHtml = DOMPurify.sanitize(record.meetz_email_body || "No email body to show");

          // Create a temporary div to strip the HTML tags and get plain text
          // const tempDiv = document.createElement("div");
          // tempDiv.innerHTML = sanitizedHtml;
          // const plainText = tempDiv.textContent || tempDiv.innerText || "";

          // const truncatedText = plainText.substring(0, 300) + "...";

          const fixedLinksInEmailBody = record?.meetz_email_body?.replace(
            /(?:href=["'])(https?:\/\/)?(www\.)?([^"']+)(?:["'])/gi,
            (match, protocol, www, domain) => {
              const fullUrl = `https://www.${domain}`;
              return `href="${fullUrl}"`;
            }
          );

          console.log(fixedLinksInEmailBody, "fixedLinksInEmailBody");
          return (
            <Space direction={"vertical"} key={record.id}>
              <Col>
                <Typography.Paragraph className={"email-title"}>
                  {record.meetz_email_subject === "ReplyTo" ? "" : record.meetz_email_subject}
                </Typography.Paragraph>
                {/* <Typography.Paragraph ellipsis={true} style={{ width: 300 }}>
                {}
              </Typography.Paragraph> */}
                {record?.meetz_email_body && record?.meetz_email_body?.length > 150 ? (
                  <Tooltip
                    placement={"right"}
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(fixedLinksInEmailBody || "No email body to show"),
                        }}
                      />
                    }
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fixedLinksInEmailBody?.substring(0, 150) + "..." || "No email body to show") }}
                    />
                  </Tooltip>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fixedLinksInEmailBody || "No email body to show") }} />
                )}
                {/* <TextEditor
                content={record.meetz_email_body || "No email body to show"}
                readOnly
                // isMaxHeight
                // style={{ width: 350 }}
              /> */}
              </Col>
              <Col>
                <Row wrap={false} style={{ gap: 3 }}>
                  {/* {!record?.is_manual_email_reply_id ? ( */}
                  {!record.step_number || !fixCampName?.length ? (
                    <> {/* <Typography.Paragraph>{`Manual email you sent`}</Typography.Paragraph> */}</>
                  ) : (
                    <>
                      {" "}
                      <Typography.Paragraph>{`Step ${record.step_number} in`}</Typography.Paragraph>
                      <Typography.Paragraph
                        className={"emails-company-name"}
                        style={{ cursor: actCampId ? "pointer" : "default" }}
                        onClick={() => actCampId && navigate(`/campaign/${btoa(`${actCampId + 12000}`)}`)}
                      >
                        {fixCampName && fixCampName?.length > 25 ? (
                          <Tooltip placement={"right"} title={`Campaign Name: ${fixCampName}`}>
                            {fixCampName?.substring(0, 25) + "..."}
                          </Tooltip>
                        ) : (
                          fixCampName
                        )}
                      </Typography.Paragraph>
                    </>
                  )}
                </Row>
              </Col>
            </Space>
          );
        } else {
          // const sanitizedHtml = DOMPurify.sanitize(record.meetz_email_body || "No email body to show");

          // // Create a temporary div to strip the HTML tags and get plain text
          // const tempDiv = document.createElement("div");
          // tempDiv.innerHTML = sanitizedHtml;
          // const plainText = tempDiv.textContent || tempDiv.innerText || "";

          // const truncatedText = plainText.substring(0, 300) + "...";
          return (
            <Space direction={"vertical"} key={record.id}>
              <Col>
                <Typography.Paragraph className={"email-title"}>{record.replied_email_subject}</Typography.Paragraph>
                {/* <Typography.Paragraph ellipsis={true} style={{ width: 300 }}>
                {}
              </Typography.Paragraph> */}
                {record?.replied_email_body && record?.replied_email_body?.length > 150 ? (
                  <Tooltip
                    placement={"right"}
                    title={<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(record?.replied_email_body || "No email body to show") }} />}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(record.replied_email_body?.substring(0, 150)?.replace(/\n/g, "<br />") + "..." || "No email body to show"),
                      }}
                    />

                    {/* <div
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(record.replied_email_body?.substring(0, 150) + "..." || "No email body to show") }}
                    /> */}
                  </Tooltip>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: record.replied_email_body?.replace(/\n/g, "<br />") || "No email body to show" }} />
                )}
                {/* <TextEditor
                content={record.meetz_email_body || "No email body to show"}
                readOnly
                // isMaxHeight
                // style={{ width: 350 }}
              /> */}
              </Col>
              <Col>
                <Row wrap={false} style={{ gap: 3 }}>
                  <Typography.Paragraph>{`Step ${record.step_number} in`}</Typography.Paragraph>
                  <Typography.Paragraph
                    className={"emails-company-name"}
                    style={{ cursor: actCampId ? "pointer" : "none" }}
                    onClick={() => actCampId && navigate(`/campaign/${btoa(`${actCampId + 12000}`)}`)}
                  >
                    {fixCampName && fixCampName?.length > 25 ? (
                      <Tooltip placement={"right"} title={`Campaign Name: ${fixCampName}`}>
                        {fixCampName?.substring(0, 25) + "..."}
                      </Tooltip>
                    ) : (
                      fixCampName
                    )}
                  </Typography.Paragraph>
                </Row>
              </Col>
            </Space>
          );
        }
      },
      key: "contents",
      align: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, value) => {
        // console.log(value, "value213");
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
            {/* {value.map((item: App.EmailStatus, index: number) => ( */}
            <EmailsStatus status={value.fixedFrontEndAnalytic} count={value.count} style={{ margin: 0 }} />
            {value?.analyticToShow?.is_ai_step ? (
              <>
                <StatusTag color={"blue"} value={"Ai Personalized Step"} style={{ margin: 0, marginTop: "10px" }} />{" "}
                {value?.analyticToShow?.used_skip_ai_defemail ? (
                  <Tooltip
                    // style={{ zIndex: 100 }}
                    placement={"right"}
                    title={`Default was used since you ran out of Ai Personalized Email credits when this email was sent out`}
                  >
                    <div>
                      {" "}
                      <StatusTag color={"volcano"} value={"Default Used"} style={{ margin: 0, marginTop: "10px" }} />
                    </div>
                  </Tooltip>
                ) : (
                  ""
                )}
              </>
            ) : (
              <StatusTag color={"green"} value={"Templated Email"} style={{ margin: 0, marginTop: "10px" }} />
            )}
            {/* ))} */}
          </div>
        );
      },
      key: "status",
      align: "center",
    },
    {
      title: activeId === "email_replied" ? "Date responded" : activeId === "email_sent" ? "Date Sent" : "Date Most Recently Happened",
      dataIndex: "maxTime",
      key: "dateSent",
      align: "center",
      render: (value) => {
        // console.log(activeId, "efiawhbasdf");
        return formatUnixTimestamp(value);
      },
    },
  ]?.filter(Boolean);

  const dataToUse = dataAll;

  const [page, setPage] = useState(1);

  const dispatch = useDispatch<AppDispatch>();

  // console.log(dataToUse, "dataToUse", page, dataToUse.availPages, dataToUse.totalAmnt);
  const handleChangePage = (pg) => {
    dispatch(
      getUnifiedInboxAll({
        analyticToGet: activeId,
        page: pg,
        // pageSize,
        // dateRange,
        campaignId: dataAll?.campaignId,
        start: analyticDates?.[0] || null,
        end: analyticDates?.[1] || null,
      })
    );
    setPage(pg);
  };

  useEffect(() => {
    setPage(1);
  }, [activeId]);

  // const [form] = Form.useForm();

  // const onFinish = (vals) => {
  //   // if (isSubmitting) return;
  //   // setIsSubmitting(true);
  //   // console.log(vals, "VALSVALS");

  //   // dispatch(addNewCampaignV2({ copyCampaign: { campName: vals?.name, campIdToCopy: vals?.camptocopy } }));
  //   closeModal();
  // };
  useEffect(() => {
    // makes sure that the GOOGLE tag is not added to the link
    document.querySelectorAll("a").forEach((a) => {
      if (a.target === "_blank" && a.href && a.href.startsWith("http")) {
        const url = new URL(a.href, window.location.origin);
        const cleanHref = url.origin + url.pathname;

        a.href = cleanHref;

        const handleClick = (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          setTimeout(() => window.open(cleanHref, "_blank"), 0);
        };

        const newA = a.cloneNode(true);
        newA.addEventListener("click", handleClick);
        a.replaceWith(newA);
      }
    });
  }, [dataToUse]);
  console.log(dataToUse?.prospectsInRowsList, "dataToUse?.prospectsInRowsList");

  return (
    <React.Fragment>
      {" "}
      <Flex justify={"center"} align={"center"} style={{ marginBottom: "7px" }}>
        <Typography.Title level={3}>Unified Inbox</Typography.Title>
        <Button className={"link"} style={{ marginLeft: "auto", marginRight: "15px" }} onClick={() => setOpenDownloadAnaltrics(true)}>
          Download Analytics
        </Button>
      </Flex>{" "}
      {/* - more features for full flexibility coming out today! */}
      <br />
      {/* <TableHeader searchPlaceholder={"Search Emails..."} /> */}
      {isTourStep ? (
        <Table customClassName={"emails-table"} columns={columns} dataSource={memoizedTourStepData} />
      ) : (
        // make page change in index only if dif than previous results
        <Table
          customClassName={"emails-table"}
          loading={!dataToUse?.campaignId}
          columns={columns}
          dataSource={dataToUse?.prospectsInRowsList || []}
          locale={{
            emptyText: (
              <Empty
                image={<Image preview={false} src={NoData} alt={"No data"} width={173} height={150} />}
                imageStyle={{
                  height: 180,
                  marginTop: "30px",
                }}
                description={
                  <span style={{ marginTop: "10px" }}>No analytics to display, create and activate a campaign to start seeing prospect activity.</span>
                } // Add margin to separate text from the image
              />
            ),
          }}
          divWidth={sdBarCollapsed ? "calc(100vw - 230px)" : "calc(100vw - 400px)"}
          // setCurrentPage={(num) => handleChangePage(num)}
          // totalAmnt={dataToUse}
          pageSize={10}
          totalAmnt={dataToUse.totalAmnt || 0}
          currentPage={page}
          setCurrentPage={handleChangePage}
          totalPages={dataToUse.availPages || 1}
          quickDropdownSkip
          quickSkip
        />
      )}
      {selectedContact && <EmailDetailsModal open={openModal} onCancel={onCancel} selectedContact={selectedContact} />}
      <DownloadEmailAnalytics open={openDownloadAnaltrics} onClose={() => setOpenDownloadAnaltrics(false)} />
    </React.Fragment>
  );
};
